<template>
  <Modal
    name="HOST_ONBOARDING_CHANGE_STEP"
    :title="!next ? 'Mudança de passo' : 'Aprovação de passo'"
  >
    <template v-slot:body>
      <div>
        <v-row v-if="hostOnboardingStepData.type == 'REGISTRATION' && next" no-gutters>
          <v-col>
            <v-alert v-if="!hasBackgroundCheck" color="orange lighten-5" class="warning--text">
              <div class="d-flex ma-2 my-4">
                <v-icon color="warning">mdi-information-outline</v-icon>
                <span class="ml-4">{{$t('hostOnboarding.warnings.backgroundCheckNotStarted')}}</span>
              </div>
            </v-alert>
            <v-alert v-if="hasBackgroundCheck && !backgroundCheckCompleted" color="orange lighten-5" class="warning--text">
              <div class="d-flex ma-2 my-4">
                <v-icon color="warning">mdi-information-outline</v-icon>
                <span class="ml-4">{{$t('hostOnboarding.warnings.backgroundCheckInProgress')}}</span>
              </div>
            </v-alert>
            <v-alert v-if="hasBackgroundCheck && backgroundCheckBadScore" color="orange lighten-5" class="warning--text">
              <div class="d-flex ma-2 my-4">
                <v-icon color="warning">mdi-information-outline</v-icon>
                <span class="ml-4">{{$t('hostOnboarding.warnings.backgroundCheckBadScore')}}</span>
              </div>
            </v-alert>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col>
            <span v-if="next">
              Você está prestes a aprovar o passo '{{currentStep}}' de '{{host.name}}'. Seu próximo passo será '{{nextStep}}'.
            </span>
            <span v-else>
              Você está prestes a mudar o passo '{{currentStep}}' para '{{nextStep}}'.
            </span>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-btn @click="closeModal('HOST_ONBOARDING_CHANGE_STEP')" outlined color="primary">
              {{$t('hostOnboarding.actions.cancel')}}
            </v-btn>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn @click="updateOnboardingStep" :loading="isLoadingButton" color="primary">
              {{$t('hostOnboarding.actions.confirm')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalHostOnboardingStepChange',

  props: {
    host: {
      type: Object
    },
    next: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  components: {
    Modal
  },

  data() {
    return {
      steps: [
        {order: 1, type: 'REGISTRATION'},
        {order: 2, type: 'COURSE'},
        {order: 3, type: 'TALK'},
        {order: 4, type: 'TEORIC_TEST'},
        {order: 5, type: 'TEST_SERVICE'},
        {order: 6, type: 'AGREEMENT'},
        {order: 7, type: 'DONE'},
      ],
    }
  },

  computed: {
    ...mapGetters(['isLoadingButton', 'hostBackgroundCheck', 'hostOnboardingStepData']),

    currentStep() {
      return this.$t(`hostOnboarding.types.${this.hostOnboardingStepData.type}`) 
    },
    nextStep() {
      if (this.next) {
        return this.$t(`hostOnboarding.types.${this.steps.find((it) => it.order == this.steps.findIndex((it) => it.type == this.hostOnboardingStepData.type) + 2).type}`) 
      } else {
        return this.$t(`hostOnboarding.types.${this.$parent.selectedStep}`)
      }
    },

    hasBackgroundCheck() {
      return Object.keys(this.hostBackgroundCheck).length
    },

    backgroundCheckCompleted() {
      return this.hostBackgroundCheck.status == 'COMPLETED'
    },

    backgroundCheckBadScore() {
      return this.backgroundCheckCompleted && this.hostBackgroundCheck.score < 0.8
    }
  },

  methods: {
    ...mapActions(['nextHostOnboardingStep', 'changeHostOnboardingStep', 'closeModal']),

    updateOnboardingStep() {
      if (this.next) {
        this.nextHostOnboardingStep(this.host.id)
      } else {
        var request = {
          host_id: this.host.id,
          type: this.$parent.selectedStep
        }
        this.changeHostOnboardingStep(request)
      }
    }
  },
}
</script>
